import { render, staticRenderFns } from "./MemGroup.vue?vue&type=template&id=19f6e06e&scoped=true"
import script from "./MemGroup.vue?vue&type=script&lang=js"
export * from "./MemGroup.vue?vue&type=script&lang=js"
import style0 from "./MemGroup.vue?vue&type=style&index=0&id=19f6e06e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f6e06e",
  null
  
)

export default component.exports